/**
 * Endkundenrechner API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Die Sortierung der Ergebnisliste, wie der Kunde sie zuletzt aktiv hatte. Erzeugte Dokumente übernehmen diese Reihenfolge; ohne Angabe wird aufsteigend nach Beitrag sortiert.
 */
export enum SortErgebnis {

    Beitrag = 'Beitrag',

    Versicherer = 'Versicherer',

    Bewertung = 'Bewertung'
}

